export const enum SortOrders {
    Ascending = 'Ascending',
    Descending = 'Descending',
}
